import { Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNav } from '../contexts/NavContext';

export function Footer() {
  const { session } = useAuth();
  const { navigateTo } = useNav();

  return (
    <footer className="hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 xl:px-8 py-6 sm:py-8">
        <div className="flex flex-col xl:flex-row justify-between items-center gap-4 sm:gap-6">
          <div className="text-center xl:text-left">
            <p className="text-purple-900 font-medium flex items-center gap-2 justify-center xl:justify-start">
              <Sparkles className="w-5 h-5" />
              Talentfunn
            </p>
            <p className="text-sm text-gray-600 mt-1">
              Vis hva du kan. Finn den som kan det.
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Innovara AS | Org.nr: 933 184 048
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 sm:gap-6 items-center text-center">
            <button
              onClick={() => navigateTo('privacy')}
              className="text-sm text-gray-600 hover:text-purple-600 transition-colors underline"
            >
              Personvern
            </button>
            <button
              onClick={() => navigateTo('terms')}
              className="text-sm text-gray-600 hover:text-purple-600 transition-colors underline"
            >
              Vilkår
            </button>
            <button
              onClick={() => navigateTo('faq')}
              className="text-sm text-gray-600 hover:text-purple-600 transition-colors underline"
            >
              FAQ
            </button>
            {session && (
              <button
                onClick={() => navigateTo('settings')}
                className="text-sm text-gray-600 hover:text-purple-600 transition-colors underline"
              >
                Innstillinger
              </button>
            )}
            <p className="text-sm text-gray-500 w-full sm:w-auto">
              © {new Date().getFullYear()} Talentfunn
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}